import { AgGrid } from "@jsq/ds/core";
import { GetPayeesQuery } from "../../../../graphql/supergraph.index";
import { PayeeDisplayStatusTypes } from "../../constants";
import { PayeeRowItem } from "./types";

/**
 * Maps payee status values to display values for the table
 */
const statusDisplayMapper: Record<string, PayeeDisplayStatusTypes> = {
  approved: PayeeDisplayStatusTypes.Approved,
  pending: PayeeDisplayStatusTypes.Pending,
  rejected: PayeeDisplayStatusTypes.Rejected,
};

/**
 * This utility function takes in a Payees query result and
 * transforms each payee into a row object that is passed into AGGrid.
 *
 * It also returns a rowCount property that tells AGGrid of the total number of rows
 * so it knows when to stop paginating.
 */
export const toLoadPayeeSuccessParams = (
  data: GetPayeesQuery,
): { resp: AgGrid.LoadSuccessParams } => {
  const rowData: PayeeRowItem[] =
    data.payees?.edges?.map((edge) => {
      const payee = edge?.node;

      return {
        id: payee.id,
        payeeName: payee.name,
        clientName: payee.arena.name,
        arenaId: payee.arena.id,
        payeeType: payee.payeeType,
        paymentMethod: payee.paymentPref.paymentMethod,
        receivingAccount: payee.paymentPref.bankInfoRedacted,
        status: statusDisplayMapper[payee.status] || payee.status,
      };
    }) || [];
  return {
    resp: {
      rowData: rowData || [],
      rowCount: data.payees?.count || 0,
    },
  };
};
